"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledTextarea = exports.StyledInput = exports.StyledInputWrap = exports.StyledIconWrapper = exports.StyledNotion = exports.StyledField = exports.StyledRequiredStar = exports.StyledLabel = exports.StyledLabelWrapper = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
exports.StyledLabelWrapper = styled_components_1.default.label `
  position: absolute;
  top: 14px;
  left: 12px;
  right: 24px;
  display: flex;

  font-size: 14px;
  line-height: 20px;
  color: #909090;

  cursor: pointer;
  transition: 0.3s;
  transition-property: top, color, opacity, font-size, font-weight, line-height;
`;
exports.StyledLabel = styled_components_1.default.span `
  display: block;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
`;
exports.StyledRequiredStar = styled_components_1.default.span `
  position: relative;
  left: 2px;
  color: #e73030;
`;
exports.StyledField = styled_components_1.default.div `
  position: relative;
`;
exports.StyledNotion = styled_components_1.default.div `
  margin: 0 13px;
  font-size: 12px;
  line-height: 18px;
  color: ${({ hasError }) => (hasError ? 'var(--error, #e73030)' : '#909090')};
`;
exports.StyledIconWrapper = styled_components_1.default.button `
  position: absolute;
  z-index: 2;
  top: 0;
  bottom: 0;
  right: 12px;
  display: flex;
  align-items: center;
  padding: 0;
  border: none;
  background: transparent;
  transition: color 0.2s ease-in-out;

  outline: none;
  cursor: ${({ clickable }) => (clickable ? 'pointer' : 'default')};
  color: ${({ isColored }) => isColored ? 'var(--primary-color, #367bf5)' : 'var(--dark, #212121)'};

  &:hover {
    ${({ clickable }) => (clickable ? 'color: var(--dark, #212121)' : '')};
    opacity: ${({ clickable, isColored }) => clickable && !isColored ? '0.8' : '1'};
  }

  &:disabled {
    color: ${({ disabled }) => disabled ? '#909090' : 'var(--primary-color, #367bf5)'};
    cursor: default;
  }

  &:disabled:hover {
    opacity: 1;
  }
`;
exports.StyledInputWrap = styled_components_1.default.div `
  position: relative;
  display: grid;
  flex: 1;

  font-size: 16px;
  line-height: 24px;
  word-break: break-word;
  cursor: ${({ disabled }) => (disabled ? 'default' : 'pointer')};

  ${({ disabled, hasError }) => disabled
    ? ''
    : `&:hover ${exports.StyledInput} {
    border: 1px solid;
    border-color: ${hasError ? 'var(--error, #e73030)' : '#909090'};
  }`}
`;
exports.StyledInput = styled_components_1.default.input `
  display: block;
  box-sizing: border-box;
  grid-area: 1 / 1 / 2 / 2;
  padding: ${(props) => (props.withIcon ? '19px 36px 0 12px' : '19px 12px 0')};
  width: 100%;
  min-height: 48px;
  border: 1px solid;
  border-color: ${(props) => props.hasError ? 'var(--error, #e73030)' : '#ebebeb'};
  border-radius: 8px;
  font: inherit;
  color: var(--dark, #212121);
  font-size: 14px;
  line-height: 20px;
  background: transparent;
  outline: none;
  cursor: pointer;

  &:not(:read-only):focus,
  &:not(:placeholder-shown) {
    outline: 0;
    cursor: ${({ onClick }) => (!!onClick ? 'pointer' : 'initial')};
    border: 1px solid;
    border-color: ${({ hasError }) => hasError ? 'var(--error, #e73030)' : '#909090'};

    + ${exports.StyledLabelWrapper} {
      top: 2px;
      background: #fff;
    }

    + ${exports.StyledLabelWrapper} {
      font-size: 12px;
      line-height: 18px;

      cursor: default;
    }

    + ${exports.StyledLabelWrapper} ${exports.StyledRequiredStar} {
      font-size: 11px;
    }
  }

  &:disabled {
    border: 1px solid #ebebeb;
    background-color: #ebebeb;
    cursor: default;

    + ${exports.StyledLabelWrapper} {
      background-color: #ebebeb;
      cursor: default;
    }
  }
`;
exports.StyledTextarea = (0, styled_components_1.default)(exports.StyledInput).attrs({
    as: 'textarea',
}) `
  max-height: 300px;
  overflow-x: hidden;
  resize: none;

  scrollbar-width: thin;
  scrollbar-color: #909090 #ebebeb;

  &::-webkit-scrollbar {
    height: 8px;
    width: 8px;
  }

  &::-webkit-scrollbar-track {
    background: #ebebeb;
    border-radius: 10px;
  }

  &::-webkit-scrollbar-thumb {
    background: #909090;
    border-radius: 10px;
  }

  & ~ ${exports.StyledIconWrapper} {
    top: 14px;
    bottom: unset;
  }
`;
//# sourceMappingURL=input-text.styled.js.map